import { styled } from "@mui/material";
import { responsiveFontSizes } from "../../utils/responsive";

export const GadsWrapper = styled("div")(() => ({
  //display: "flex",
  height: "100%"
  // backgroundColor: "white",
  // "& .left-container": {
  //   width: "20%",
  //   backgroundColor: "white",
  //   overflow: "hidden"
  // },
}));
